import React from "react";

import { cn } from "../utils";

interface MarqueeProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  reverse?: boolean;
  pauseOnHover?: boolean;
  children?: React.ReactNode;
  vertical?: boolean;
  repeat?: number;
  rowClassName?: string;
}

export const Marquee = ({
  className,
  reverse,
  pauseOnHover = false,
  children,
  vertical = false,
  repeat = 4,
  rowClassName,
  ...props
}: MarqueeProps) => (
  <div
    {...props}
    className={cn(
      "group flex gap-(--gap) overflow-hidden p-2 [--duration:20s] [--gap:1rem]",
      {
        "flex-row": !vertical,
        "flex-col": vertical,
      },
      className,
    )}
  >
    {Array(repeat)
      .fill(0)
      .map((_, i) => (
        <div
          key={i}
          className={cn(
            "flex shrink-0 justify-around gap-(--gap)",
            {
              "animate-marquee flex-row": !vertical,
              "animate-marquee-vertical flex-col": vertical,
              "group-hover:[animation-play-state:paused]": pauseOnHover,
              "[animation-direction:reverse]": reverse,
            },
            rowClassName,
          )}
        >
          {children}
        </div>
      ))}
  </div>
);
